import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import MultiInput from '@Components/MultiInput';

import './SendAlertsToRow.scss';

export default class SendAlertsToRow extends React.PureComponent {
  render() {
    const {
      emailsMultiInput,
      showNonOwnerEmailMessage,
      addAlertFormEmail,
      removeAlertFormEmail,
      validateEmailsInputOnSelect,
      validateEmailsInputOnChange,
    } = this.props;

    const blockAdditionalAlertEmail = Auth.isFeatureEnabled(FEATURES.block_additional_alert_email);

    return (
      <div className="create-alert-dialog-row create-alert-dialog-row-emails">
        <div className={cn('create-alert-dialog-column-label', { disabled: blockAdditionalAlertEmail })}>Send alerts to:</div>
        <div className="create-alert-dialog-column-content">
          <MultiInput
            className="create-alert-email"
            classNameInput="create-alert-email-input"
            placeholder="Email address"
            values={emailsMultiInput}
            multiInputValidateOnSelect={validateEmailsInputOnSelect}
            multiInputValidateOnChange={validateEmailsInputOnChange}
            multiInputOnSelect={addAlertFormEmail}
            multiInputOnRemove={removeAlertFormEmail}
            additionDisabled={blockAdditionalAlertEmail}
            description="Enter one or more recipient email addresses to send email alerts"
          />
          {showNonOwnerEmailMessage && (
            <div className="non-owner-email-message">
              Please ensure you have the email address owners permission before you sign them up for this alert. Your email address will be
              included in the alert acceptance message.
            </div>
          )}
        </div>
      </div>
    );
  }
}

SendAlertsToRow.propTypes = {
  emailsMultiInput: PropTypes.array.isRequired,
  showNonOwnerEmailMessage: PropTypes.bool,
  addAlertFormEmail: PropTypes.func.isRequired,
  removeAlertFormEmail: PropTypes.func.isRequired,
  validateEmailsInputOnSelect: PropTypes.func.isRequired,
  validateEmailsInputOnChange: PropTypes.func.isRequired,
};
